import React from 'react';

import { useTranslations } from 'next-intl';
import NextImage from 'next/image';

interface PropTypes {
  data: {
    internal_rating: number;
    imdb_rating?: number;
  };
}

function MovieOrTvRating({ data }: PropTypes) {
  const t = useTranslations();

  return (
    <div className="flex flex-row justify-start items-center mt-8">
      <div className="flex flex-row items-center">
        <NextImage
          className="rounded-md mr-2"
          src="/assets/app/rating-logo.svg"
          width={113}
          height={40}
          alt={t('movie_or_tv_rating.trakio_rating_alt')}
        />
        <span className="text-white text-center font-bold text-lg md:text-xl">
          {data.internal_rating.toFixed(1)}/10
        </span>
      </div>

      {data.imdb_rating && (
        <div className="flex flex-row items-center ml-10">
          <NextImage
            className="rounded-md mr-2"
            src="/assets/app/imdb-rating-logo.svg"
            width={50}
            height={40}
            alt={t('movie_or_tv_rating.imdb_rating_alt')}
          />
          <span className="text-white text-center font-bold text-lg md:text-xl">
            {data.imdb_rating.toFixed(1)}/10
          </span>
        </div>
      )}
    </div>
  );
}

export default MovieOrTvRating;
